import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CourseEnrollmentContainerComponent } from './enrollment-containers/course-enrollment-container/course-enrollment-container.component';
import { UserCreationContainerComponent } from '../../../domains/organization/user/components/user-creation-container/user-creation-container.component';
import { ActivatedRoute, Router } from '@angular/router';
import { distinctUntilChanged, map, Subject, takeUntil } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { UserCsvUploadContainerComponent } from '../../../domains/organization/user/components/user-csv-upload-container/user-csv-upload-container.component';
import { UserCreationNotificationService } from '../../../domains/organization/user/services/user-creation-notification.service';
import { LearningPlanEnrollmentContainerComponent } from './enrollment-containers/learning-plan-enrollment-container/learning-plan-enrollment-container.component';

export enum DialogSteps {
  ENROLL = 'enroll',
  CREATE = 'create',
  CSV = 'csv',
}

@Component({
  selector: 'app-enrollment-user-creation-dialog-container',
  imports: [
    CourseEnrollmentContainerComponent,
    UserCreationContainerComponent,
    UserCsvUploadContainerComponent,
    LearningPlanEnrollmentContainerComponent,
  ],
  templateUrl: './enrollment-user-creation-dialog-container.component.html',
})
export class EnrollmentUserCreationDialogContainerComponent
  implements OnInit, OnDestroy
{
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly userCreationNotificationService = inject(
    UserCreationNotificationService,
  );
  dialogRef =
    inject<MatDialogRef<EnrollmentUserCreationDialogContainerComponent>>(
      MatDialogRef,
    );

  step: string;
  dialogSteps = DialogSteps;
  isLearningPlansRoute: boolean;
  private readonly destroy$: Subject<void> = new Subject();

  ngOnInit(): void {
    this.isLearningPlansRoute = this.router.url.includes('/learningPlans');
    this.activatedRoute.queryParams
      .pipe(
        map((params) => params['step'] as DialogSteps),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
      )
      .subscribe((step) => {
        this.step = step;
      });
  }

  showEnrollmentContent() {
    void this.router.navigate([], {
      queryParams: { step: DialogSteps.ENROLL },
    });
  }

  showUserCreationContent() {
    void this.router.navigate([], {
      queryParams: { step: DialogSteps.CREATE },
    });
  }

  showCsvUploadContent() {
    void this.router.navigate([], { queryParams: { step: DialogSteps.CSV } });
  }

  goBack() {
    const currentRoute = this.router.url;
    if (currentRoute.includes('/portal/team/')) {
      this.closeDialog();
    } else {
      this.showEnrollmentContent();
    }
  }

  handleUserSuccessfullyCreatedEvent() {
    this.userCreationNotificationService.setUserChangedNotification();
    this.goBack();
  }

  onAddLicensesButtonClick(): void {
    this.dialogRef.afterClosed().subscribe(() => {
      void this.router.navigate(['/portal/billing']);
    });
    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
